import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { FC } from 'react'
import { dateSelectStyles } from './styles'

type DateSelectProps = DatePickerProps & { fullWidth?: boolean, helperText?: string, error?: boolean, size?: 'small' | 'medium' }

export const DateSelect: FC<DateSelectProps> =
    ({ fullWidth, helperText, error, size = 'small', ...props }) => {
        // Use slotProps to pass props to the textField component
        // This is the recommended approach in newer versions of MUI X Date Pickers
        const slotProps = {
            textField: {
                fullWidth: fullWidth || false,
                helperText,
                error,
                size,
            },
        }

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker sx={dateSelectStyles.root} slotProps={slotProps} {...props} />
            </LocalizationProvider>
        )
    }
